import React, { Component } from "react";
import RequestsComponent from '../components/RequestComponent';
import Landing from './../../landing/containers/LandingContainer';
import { sendService } from "../../Services/service";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../Actions/Dashboard';
import * as ModalActs from './../../Actions/Modal';

import "../style.css";


class Requests extends Component {
  state = {
    page: 0,
    control: { count: 0, rows: [] }
  }

  onChangeRoute = (route) => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  }

  componentDidMount() {
    this.getPageData()
  }

  getPageData = (page = 0) => {
    sendService(`/api/v1/citizen/listGob/${page}`, "GET").then(value => {
      if (value.status === 200)
        this.setState({ control: value.response })
    })
  };


  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <RequestsComponent
          state={this.state}
          onChangePage={this.getPageData}
          onChangeRoute={this.onChangeRoute}
        />
      </Landing>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(ModalActs, dispatch),
  }
}

export default connect(null, mapDispatchToProps)(Requests);